export default __webpack_public_path__ + "static/media/09.1e49b89b.jpg";